
import Card from '../base/Card';

export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-robot-line',
      title: 'Procesamiento con IA',
      description: 'Sube tu resumen de tarjeta en PDF y nuestra inteligencia artificial clasificará automáticamente todos tus gastos por categorías.',
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Proyecciones Inteligentes',
      description: 'Visualiza estimaciones futuras de tus gastos y calcula tu ahorro proyectado con interés compuesto para planificar mejor.',
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-100'
    },
    {
      icon: 'ri-dashboard-3-line',
      title: 'Dashboard Interactivo',
      description: 'Gráficos dinámicos que puedes personalizar entre formato torta y barras, con desglose detallado al hacer clic.',
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      icon: 'ri-folder-organize-line',
      title: 'Organización Total',
      description: 'Mantén todos tus ingresos y gastos organizados en un solo lugar, con categorización automática y manual.',
      color: 'text-orange-600',
      bgColor: 'bg-orange-100'
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Visualizaciones Poderosas',
      description: 'Comprende tu situación financiera de un vistazo con gráficos claros y análisis de tendencias mensuales.',
      color: 'text-teal-600',
      bgColor: 'bg-teal-100'
    },
    {
      icon: 'ri-safe-line',
      title: 'Enfoque en Ahorro',
      description: 'Herramientas especializadas para ayudarte a identificar oportunidades de ahorro e inversión inteligente.',
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-100'
    }
  ];
  
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Funcionalidades que Transforman tu Gestión Financiera
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Descubre cómo Invirtiendo utiliza tecnología avanzada para simplificar 
            y potenciar tu control financiero personal.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card key={index} className="text-center hover:shadow-xl transition-shadow duration-300">
              <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto mb-6`}>
                <i className={`${feature.icon} text-2xl ${feature.color}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </Card>
          ))}
        </div>
        
        {/* Sección de carga de PDF */}
        <div className="mt-20">
          <Card className="text-center bg-gradient-to-r from-emerald-50 to-blue-50 border-emerald-200">
            <div className="max-w-4xl mx-auto">
              <div className="mb-8">
                <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="ri-file-pdf-line text-3xl text-emerald-600"></i>
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  Carga Automática con Inteligencia Artificial
                </h3>
                <p className="text-xl text-gray-600 mb-8">
                  Simplifica tu vida financiera. Solo sube el PDF de tu resumen de tarjeta 
                  y nuestra IA se encarga del resto.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">1</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Sube tu PDF</h4>
                    <p className="text-gray-600 text-sm">
                      Arrastra o selecciona el resumen de tu tarjeta de crédito en formato PDF.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">2</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">IA Procesa</h4>
                    <p className="text-gray-600 text-sm">
                      Nuestra inteligencia artificial lee y clasifica automáticamente cada transacción.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-4">
                  <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <span className="text-sm font-bold">3</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">Visualiza</h4>
                    <p className="text-gray-600 text-sm">
                      Obtén gráficos instantáneos y análisis detallado de tus gastos organizados.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
}
